import { createSlice } from '@reduxjs/toolkit';
import { createMaterial, IMaterial, IMaterialsPerSubActivity } from '../../../models/materials';

interface IMaterialState {
    error: string,
    isError: boolean,
    isLoading: boolean,
    isSaved: boolean,
    material: IMaterial,
    materials: IMaterial[],
    materialsPerSubActivity: IMaterialsPerSubActivity[],
    materialsPerSubActivityBase: IMaterialsPerSubActivity[],
    selectedIdMaterialsPerSubActivity: number[],
    tempMaterialsPerSubActivity: IMaterialsPerSubActivity[],
};

const initialState: IMaterialState = {
    error: '',
    isError: false,
    isLoading: false,
    isSaved: false,
    material: createMaterial({}),
    materials: [],
    materialsPerSubActivity: [],
    materialsPerSubActivityBase: [],
    selectedIdMaterialsPerSubActivity: [],
    tempMaterialsPerSubActivity: [],
};

export const materialsSlice = createSlice({
    name: 'materials',
    initialState,
    reducers: {
        setMaterial: (state, action) => {
            state.isLoading = false;
            state.material = action.payload.material;
            state.isError = false;
            state.error = '';
        },
        setMaterials: (state, action) => {
            state.isLoading = false;
            state.materials = action.payload.materials;
            state.isError = false;
            state.error = '';
        },
        setTempMaterialsPerSubActivity: (state, action) => {
            state.tempMaterialsPerSubActivity = action.payload.tempMaterialsPerSubActivity;
            state.selectedIdMaterialsPerSubActivity = action.payload.selectedIdMaterialsPerSubActivity;
        },
        setMaterialsPerSubActivity: (state, action) => {
            state.isLoading = false;
            state.materialsPerSubActivity = action.payload.materialsPerSubActivity;
            state.tempMaterialsPerSubActivity = action.payload.materialsPerSubActivity;
            state.materialsPerSubActivityBase = action.payload.materialsPerSubActivityBase;
        },
        startLoadingMaterials: (state) => {
            state.isLoading = true;
        },
        errorSaving: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action.payload.error;
        },
        reset: (state) => {
            state.isError = false;
            state.isSaved = false;
            state.error = "";
        },
        updateMaterials: (state, action) => {
            state.isLoading = false;
            const updated: IMaterial[] = state.materials.map((item: IMaterial) => {
                if (item.id === action.payload.material.id)
                    return action.payload.material;
                return item;
            });
            state.materials = updated;
            state.isError = false;
            state.error = '';
            state.isSaved = true;
        },
        adjustInventory: (state, action) => {
            const updated: IMaterial[] = state.materials.map((item: IMaterial) => {
                if (item.id === action.payload.material.id)
                    return action.payload.material;
                return item;
            });
            state.materials = updated;
            state.isSaved = true;
        },
    }
});

// Action creators are generated for each case reducer function
export const {
    setMaterial,
    setMaterials,
    setMaterialsPerSubActivity,
    setTempMaterialsPerSubActivity,
    startLoadingMaterials,
    errorSaving,
    reset,
    updateMaterials,
    adjustInventory
} = materialsSlice.actions;